import axios from "axios";
import store from "@/store";
import router from "@/router";

const baseDomain = ""; // "http://tsvserver:4000"
const baseURL = `${baseDomain}/api`;
const instance = axios.create({
  baseURL: baseURL
});
instance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {


    // when there is a 401 error then reroute back to login screen.
    // Network-level failures (aborted, offline, DNS) carry no response at all —
    // reading .status on those used to throw inside this interceptor, so the
    // original error never reached the caller's catch.
    if (error.response && error.response.status === 401) {
        // store.commit("showSnackBar", {
        //     color: "error",
        //     message: error.response.statusText
        // });

      store.commit("login/deleteUserLoggedIn");
      store.commit("login/logOutUser");
      router.push({ name: "login" }, () => {});
    }
    return Promise.reject(error);
  }
);
export default instance;
